import { LoggingService } from '../services/logging.service';

export function initializeLogging(loggingService: LoggingService) {
  return () => {
    return new Promise<void>((resolve) => {
      loggingService.initNavigationLogging();
      resolve();
    });
  };
}
